import React, { useContext, useState } from 'react'

import { getResumenVentasAnualbyCliente } from '../../../API/Ventas/ResumenVentasRequest';
import { useEffect } from 'react';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { resumenVentasLang } from './ResumenVentasLang';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { Button } from 'primereact/button';
import { getGenerarExcelVentaAnualCliente } from '../../../API/Ventas/ResumenVentasRequest';
import { descargarArchivo } from '../../../Base/Services/ArchivosService';
import { getLocalDateString1 } from '../../../Base/Services/FechasService';

const ResumenVentasAnualbyCliente = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalAnual, setTotalAnual] = useState({ Presupuesto: 0, Ventas: 0 });

  const { config } = useContext(ConfigContext);

  const getInfo = async () => {
    setLoading(true);
    const response = await getResumenVentasAnualbyCliente({
      year: new Date().getFullYear(),
    });
    // console.log({ response });
    if (response?.length > 0) {
      const totalPresupuesto = response.reduce((acc, item) => acc + item.Total_Presupuesto, 0);
      const totalVentas = response.reduce((acc, item) => acc + item.Total_Ventas, 0);
      setTotalAnual({ Presupuesto: totalPresupuesto, Ventas: totalVentas });
    } else {
      setTotalAnual({ Presupuesto: 0, Ventas: 0 });
    }
    
    setData(response);
    setLoading(false);
  }

  const getPorcent = (ventas, presupuesto) => {
    // console.log({ ventas, presupuesto });
    if (ventas === 0) {
      return 0;
    }
    if (presupuesto === 0) {
      return 100;
    }
    return (ventas / presupuesto) * 100;
  }

  const stylesTextBold = (params) => {
    return {
      'text-align': 'right',
      'font-weight': 'bold',
    }
  }

  const setColumMes = (mes, ventas, presupuesto, total = false) => {
    const nombreMesActual = new Date().toLocaleString('es-ES', { month: 'long' });
    // console.log({ mes, nombreMesActual });
    let cellStyle = undefined;
    if (total) {
      cellStyle = stylesTextBold;
    }
    if (mes?.toLowerCase() === nombreMesActual) {
      cellStyle = stylesTextBold;
    }
    return [
      //   headerName: mes,
      //   children: [
      // {
      //   field: presupuesto,
      //   header: 'Budget $',
      //   headerEn: '',
      //   className: 'small',
      //   Format: 'Currency',
      //   Sumary: 'sum',
      //   prefix: '$ ',
      //   frozen: total,
      //   alignFrozen: total ? 'right' : undefined,
      //   cellStyle: total ? stylesTextBold : undefined,
      //   hidden: total,
      // },
      {
        field: 'Total_KgsVentas',
        header: 'Kgs',
        headerEn: '',
        className: 'small',
        Format: 'Currency',
        Sumary: 'sum',
        // prefix: '$ ',
        frozen: total,
        hidden: total,
        alignFrozen: total ? 'right' : undefined,
        cellStyle: cellStyle

      },

      {
        field: ventas,
        header: mes + '',
        headerEn: '',
        className: 'small',
        Format: 'Currency',
        Sumary: 'sum',
        prefix: '$ ',
        frozen: total,
        alignFrozen: total ? 'right' : undefined,
        cellStyle: cellStyle
      },
      {
        field: 'Enero_Porcentaje',
        header: '%',
        type: 'rightAligned',
        Format: 'Porcentaje',
        className: 'Xsmall',
        hidden: total,
        align: 'center',
        frozen: total,
        alignFrozen: total ? 'right' : undefined,
        calcFunction: params => {
          // params.value = getPorcent(params?.data[ventas], totalAnual.Ventas)
          return getPorcent(params?.data[ventas], totalAnual.Ventas)
        },
        cellStyle: cellStyle,
        valueGetter: params => {
          return 22;
        }
      },
    ]
  }

  const rowClassRulesTotal = {
    'ag-rows-bold': (params) => (typeof params?.data?.Cliente === 'string' ? false : true),
  }


  const columns = [
    {
      field: 'Cliente',
      header: 'Cliente',
      headerEn: '',
      className: 'XXlarge',
      frozen: true,
      alignFrozen: 'left',
      Sumary: 'count',
    },
    ...setColumMes('Enero', 'Enero_Ventas', 'Enero_Presupuesto'),
    ...setColumMes('Febrero', 'Febrero_Ventas', 'Febrero_Presupuesto'),
    ...setColumMes('Marzo', 'Marzo_Ventas', 'Marzo_Presupuesto'),
    ...setColumMes('Abril', 'Abril_Ventas', 'Abril_Presupuesto'),
    ...setColumMes('Mayo', 'Mayo_Ventas', 'Mayo_Presupuesto'),
    ...setColumMes('Junio', 'Junio_Ventas', 'Junio_Presupuesto'),
    ...setColumMes('Julio', 'Julio_Ventas', 'Julio_Presupuesto'),
    ...setColumMes('Agosto', 'Agosto_Ventas', 'Agosto_Presupuesto'),
    ...setColumMes('Septiembre', 'Septiembre_Ventas', 'Septiembre_Presupuesto'),
    ...setColumMes('Octubre', 'Octubre_Ventas', 'Octubre_Presupuesto'),
    ...setColumMes('Noviembre', 'Noviembre_Ventas', 'Noviembre_Presupuesto'),
    ...setColumMes('Diciembre', 'Diciembre_Ventas', 'Diciembre_Presupuesto'),
    ...setColumMes('Total', 'Total_Ventas', 'Total_Presupuesto', true),


  ]
  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    rowClassRules: rowClassRulesTotal,
  }

  const GenerarExcel = async () => {
    setLoading(true);
    const tempoArchivos = await getGenerarExcelVentaAnualCliente({
      Mes: new Date().getMonth() + 1, 
      Anio: new Date().getFullYear()
    });
    if (tempoArchivos) {
      if (tempoArchivos?.creado) {
        let dataArchivo = tempoArchivos?.Archivo;
        if (dataArchivo) {
          let filename = "Resumen Ventas- " + getLocalDateString1(new Date());
          const downloadLink = document.createElement("a");
          const fileName = filename;
          descargarArchivo(dataArchivo, downloadLink, fileName);
        }
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div style={{ width: '100%', height: 500 }} className='px-2'>
      <div className="d-flex ">
      <h3>{getLabel(resumenVentasLang, 'TituloVentasAnualPorCliente', config.language)}</h3>
      <Button
        icon='ri-file-excel-2-fill' text loading={loading}
        onClick={() => GenerarExcel()}
      />
      </div>
      <AgGrid table={table} />
    </div>
  )
}

export default ResumenVentasAnualbyCliente